const VIEW_AS_STORAGE_KEY = "hub.adminViewAsUserId";
export const HUB_VIEW_AS_HEADER = "x-hub-view-as-user-id";

export function hubViewAsUserId(): string | null {
  if (typeof window === "undefined") return null;
  const value = window.sessionStorage.getItem(VIEW_AS_STORAGE_KEY)?.trim() || "";
  return value.length > 0 ? value : null;
}

export function hubViewAsRequestHeader(): Record<string, string> {
  const userId = hubViewAsUserId();
  return userId ? { [HUB_VIEW_AS_HEADER]: userId } : {};
}

export function clearRejectedHubViewAs(): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(VIEW_AS_STORAGE_KEY);
}

export function setHubViewAsUserId(userId: string | null): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem("hub.adminStandardUserPreview");
  if (userId && userId.trim() !== "") {
    window.sessionStorage.setItem(VIEW_AS_STORAGE_KEY, userId.trim());
  } else {
    window.sessionStorage.removeItem(VIEW_AS_STORAGE_KEY);
  }
  window.location.reload();
}
